import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  title: string
  children: React.ReactNode
} & ClassNameProps

export const PairInformationPoolItem: React.FC<Props> = ({
  title,
  children,
  className,
}) => {
  return (
    <Root className={className}>
      <Title>{title}</Title>
      <Value>{children}</Value>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  align-items: center;

  gap: 3px;
`

const Title = styled(Typography).attrs({
  variant: 'description-medium',
  component: 'div',
})`
  color: var(--text-9);
  white-space: nowrap;
`

const Value = styled(Typography).attrs({
  variant: 'body5-bold',
  component: 'div',
})`
  color: var(--white);
  white-space: nowrap;

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  align-items: center;

  gap: 3px;
`
